import { useTranslation } from "react-i18next";
import {
  Avatar,
  avatarPropsForPerson,
  formatDate,
  Icon,
  Person,
  useSnackbarContext,
  writeToClipboard,
  ProfileWidget,
} from "@inductiveautomation/ws-components";

import { getUserDataWidgetStyles } from "../_publicProfile.styles";
import { PublicProfileDetails } from "../api/publicProfile.api";

const UserDataWidget = ({ user }: { user: PublicProfileDetails }) => {
  const { t } = useTranslation("translation", { keyPrefix: "public_profile" });
  const { addSnackbar } = useSnackbarContext();
  const { classes } = getUserDataWidgetStyles();
  const hasSharedUserInfo = [
    user.primaryEmailAddress,
    user.phoneNumber,
    user.jobTitle,
    user.country,
  ].some((item) => !!item);
  return (
    <ProfileWidget
      heading={`${user.firstName} ${user.lastName}`}
      subtitle={`Since ${formatDate(new Date(user.createdAt), "date")}`}
      contentMaxHeight="unset"
      testId="profile"
      headerActions={[
        {
          actions: [
            {
              id: "share-profile",
              icon: "link",
              label: t("sections.user_card.actions.share"),
              buttonVariant: "tertiary",
              onClick: () => {
                writeToClipboard(window.location.href)
                  .then(() => {
                    addSnackbar(t("actions.copy_link.success_message"));
                  })
                  .catch((error: unknown) => {
                    addSnackbar(t("actions.copy_link.error_message"), {
                      type: "error",
                    });
                    console.error(error);
                  });
              },
            },
          ],
        },
      ]}
      leftContent={
        <Avatar size="extra_large" {...avatarPropsForPerson(user as Person)} />
      }
      rightContent={
        <div className={classes.userCardData}>
          {user.primaryEmailAddress && (
            <div data-testid="user-data-email">
              <Icon name="email-outlined" /> {user.primaryEmailAddress}
            </div>
          )}
          {user.phoneNumber && (
            <div data-testid="user-data-phone-number">
              <Icon name="phone-outlined" /> {user.phoneNumber.country} +
              {user.phoneNumber.countryCode} {user.phoneNumber.number}
            </div>
          )}
          {user.jobTitle && (
            <div data-testid="user-data-job-title">
              <Icon name="job-title-outlined" /> {user.jobTitle}
            </div>
          )}
          {user.country && (
            <div data-testid="user-data-country">
              <Icon name="language" /> {user.country}
            </div>
          )}
        </div>
      }
      useOnlyLeftContent={!hasSharedUserInfo}
    />
  );
};

export default UserDataWidget;
